import { call, takeEvery, put } from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import {
  getListedItems,
  getListedItemsSuccess,
  getListedItemsFailed,
  setError,
} from './reducer'
import { ApiError } from '../../services/api/api-error-data'
import {trackException} from '../app-insights/reducer'
import { moderationPageItems } from '../../services/api/moderation-page-items'

/* GET LISTED ITEMS WHEN APPLY FILTER Changes */
export function* getListedItemsSaga({
  payload,
}: ReturnType<typeof getListedItems>): SagaIterator {
  try {
    const data = yield call(moderationPageItems.availableListedItems, payload)
    yield put(getListedItemsSuccess({ data }))
  } catch (e) {
    yield put(getListedItemsFailed())
    yield put(setError(e as ApiError))
    yield put(trackException({e, source: 'getListedItemsSaga'}))
  }
}

export function* moderationPageItemsSaga(): SagaIterator {
  yield takeEvery(getListedItems, getListedItemsSaga)
}
